// This file is intended for global constants that are shared across
// the application. Use this file sparingly. For constants with a single
// usage, it can be better to include them in the module scope of the
// file they're used in.
export const MOBILE = 'MOBILE';
export const DESKTOP = 'DESKTOP';

export const REACT_SLICK_SPEED = 300; // in milliseconds
